import { eventTracker } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { FunnelIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

interface Props {
  canAddAlarmTypeGroup: boolean;
  hasCustomFiltersApplied: boolean;
  isLoading: boolean;
  onClickAddAlarmTypeGroup: () => void;
  onClickFilter: () => void;
}

export function TableHeader(props: Props) {
  const {
    canAddAlarmTypeGroup,
    hasCustomFiltersApplied,
    isLoading,
    onClickAddAlarmTypeGroup,
    onClickFilter,
  } = props;

  return (
    <div
      className={clsx(
        'dark:bg-dark-bg flex items-center border-b bg-white p-4 dark:border-0',
        canAddAlarmTypeGroup ? 'justify-between' : 'justify-end'
      )}
    >
      {canAddAlarmTypeGroup && (
        <Button
          variant="primary"
          onClick={onClickAddAlarmTypeGroup}
          disabled={isLoading}
          onSideEffect={eventTracker('open_add_alarm_type_group_modal')}
        >
          Add Alarm Type Group
          <span className="sr-only">Add Alarm Type Group</span>
        </Button>
      )}
      <Button
        variant="icon"
        badge={hasCustomFiltersApplied}
        onClick={onClickFilter}
        disabled={isLoading}
        onSideEffect={eventTracker('open_alarm_type_group_filters_panel')}
      >
        <span className="sr-only">Open filters panel</span>
        <FunnelIcon className="h-5 w-5" aria-hidden="true" />
      </Button>
    </div>
  );
}

export default TableHeader;
